var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0446 4C13.7545 3.99999 15.0974 3.99998 16.146 4.14095C17.2204 4.28541 18.0729 4.58749 18.7427 5.2573C19.4125 5.92711 19.7146 6.77961 19.859 7.85406C20 8.90259 20 10.2455 20 11.9554V12.0446C20 13.7545 20 15.0974 19.859 16.146C19.7146 17.2204 19.4125 18.0729 18.7427 18.7427C18.0729 19.4125 17.2204 19.7146 16.146 19.859C15.0974 20 13.7545 20 12.0446 20H11.9554C10.2455 20 8.90259 20 7.85406 19.859C6.77961 19.7146 5.92711 19.4125 5.2573 18.7427C4.58749 18.0729 4.28541 17.2204 4.14095 16.146C3.99998 15.0974 3.99999 13.7545 4 12.0446V11.9554C3.99999 10.2456 3.99998 8.90259 4.14095 7.85406C4.28541 6.77961 4.58749 5.92711 5.2573 5.2573C5.92711 4.58749 6.77961 4.28541 7.85406 4.14095C8.90259 3.99998 10.2456 3.99999 11.9554 4H12.0446Z",
    fill: "#B9BBC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45398 10.0483C9.45398 8.6466 10.5916 7.51172 11.9933 7.51172C13.395 7.51172 14.5327 8.6466 14.5327 10.0483C14.5327 11.45 13.395 12.5849 11.9933 12.5849C10.5916 12.5849 9.45398 11.45 9.45398 10.0483Z",
    fill: "#546088"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0836 16.3257C7.84977 16.1024 7.8412 15.7319 8.06445 15.4981C10.1039 13.3621 13.8608 13.2467 15.9427 15.5056C16.1617 15.7433 16.1467 16.1137 15.9089 16.3328C15.7964 16.4365 15.6541 16.4877 15.5122 16.4877H8.48783C8.34253 16.4877 8.19699 16.434 8.0836 16.3257Z",
    fill: "#546088"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientInactive);
export default __webpack_public_path__ + "static/media/client-inactive.147482f3399b694c22bce15f14ce504d.svg";
export { ForwardRef as ReactComponent };